<template>
  <div>
    <!-- <button class="toastTest" @click="testToast">Test toast</button> -->
    <div class="toastContainer">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['toast', toast.type]"
        v-on:click="removeToast(toast.id)"
      >
        {{ toast.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "@/modules/f8/hooks";

export default {
  setup() {
    const toast = useToast();
    const toasts = toast.getToasts();
    let cnt = 0;

    const testToast = () => {
      toast.addSuccess("Действие выполнено успешно! - " + cnt++);
      if (Math.random() > 0.5) {
        toast.addError("Ошибка выполнения действия! - " + cnt++);
      }
    };

    const removeToast = (id) => {
      const index = toasts.value.findIndex((t) => t.id === id);
      if (index !== -1) {
        toasts.value.splice(index, 1);
      }
    }

    return {
      toasts,
      testToast,
      removeToast
    };
  },
};
</script>

<style scoped>
.toastContainer {
  position: fixed;
  min-width: 20%;
  bottom: 48px;
  right: 32px;
  z-index: 10000;
}

.toast {
  /* position: relative; */
  background-color: var(--warning-color);
  color: var(--text-dark);
  font-size: 85%;
  padding: 8px 16px;
  border-radius: 3px;
  transition: opacity 0.3s ease;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toast:hover {
  cursor: crosshair;
}

.toast.info {
  background-color: var(--info-color);
  color: var(--text-primary);
}

.toast.success {
  background-color: var(--success-color);
  color: var(--text-white);
}

.toast.error {
  background-color: var(--danger-color);
  color: var(--text-white);
}

.toast-hide {
  display: none;
}
</style>